export const COVERAGES_BENEFIT_CATEGORY = 'coverages';
